var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPen = function SvgPen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2785 6.45938L9.54062 3.72148L10.8816 2.40754L13.5925 5.11843L12.2785 6.45938ZM4.88781 14.0001H1.99992V11.1122L8.11168 5.12144L10.8786 7.88733L4.88781 14.0001ZM11.5945 0.292623C11.2066 -0.0953614 10.5796 -0.0973613 10.1876 0.285624L0.299988 9.97824C0.107996 10.1662 0 10.4232 0 10.6922V15C0 15.552 0.447982 16 0.99996 16H5.30779C5.57578 16 5.83377 15.892 6.02176 15.7L15.7144 5.8124C16.0974 5.42042 16.0944 4.79244 15.7064 4.40446L11.5945 0.292623Z"
  })));
};
export default SvgPen;